import { render, staticRenderFns } from "./RamsNode.vue?vue&type=template&id=a1a83bb8&scoped=true"
import script from "./RamsNode.vue?vue&type=script&lang=js"
export * from "./RamsNode.vue?vue&type=script&lang=js"
import style0 from "./RamsNode.vue?vue&type=style&index=0&id=a1a83bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a83bb8",
  null
  
)

export default component.exports